import { css } from '@linaria/core';
import { PAGE_CONTENT_MAX_WIDTH } from 'styles/constants';
export const PageWrapperStyles = {
  layout: "omponents__PageWrapper__styles_ts-layout-l1v7jsqp",
  container: "omponents__PageWrapper__styles_ts-container-c1ih8qcg",
  navbar: "omponents__PageWrapper__styles_ts-navbar-n4jdjov",
  main: "omponents__PageWrapper__styles_ts-main-m1maf70r",
  contentHorizontalPlacement: "omponents__PageWrapper__styles_ts-contentHorizontalPlacement-cvy7nqp"
};

require("./styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./styles.ts");